export default __webpack_public_path__ + "static/media/STL_Intimation_of_Postal_Ballot_Notice.84e60a5e.pdf";